import React, { useRef } from "react";
import { Link } from "react-router-dom";
//library slider
import Swiper from "react-id-swiper";
// Icon Import
import Brokoli from "../../assets/icons/brokoli.svg";
import Chili from "../../assets/icons/chili.svg";
import Cookies from "../../assets/icons/cookies.svg";
import Egg from "../../assets/icons/egg.svg";
import Fish from "../../assets/icons/fish.svg";
import Fruit from "../../assets/icons/fruit.svg";
import Meat from "../../assets/icons/meat.svg";

// import css react swiper id
import "swiper/css/swiper.css";
//Arrow ico

import {ReactComponent as LeftArrow } from "../../assets/icons/lef-arrow.svg";
import {ReactComponent as RightArrow } from "../../assets/icons/right-arrow.svg";

const CategorySlide = () => {
  const swiperRef = useRef(null);
  const params = {
    slidesPerView: 6,
    spaceBetween : 5,
    slidesPerGroup: 1,
    centeredSlide : true,
    loop: true,
  };
  const goNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };
  const goPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const categoryList = [
    {
      categoryRoute: "/category",
      imgSrc: Brokoli,
      categoryName: "Sayuran",
      imgAlt : "Gambar sayuran"
    },
    {
      categoryRoute: "/category",
      imgSrc: Fruit,
      categoryName: "Buah",
      imgAlt : "Gambar Buah"
    },
    {
      categoryRoute: "/category",
      imgSrc: Egg,
      categoryName: "Sembako",
      imgAlt : "Gambar sembako"
    },
    {
      categoryRoute: "/category",
      imgSrc: Meat,
      categoryName: "Daging",
      imgAlt : "Gambar daging"
    },
    {
      categoryRoute: "/category",
      imgSrc: Chili,
      categoryName: "Bumbu",
      imgAlt : "Gambar bumbu"
    },
    {
      categoryRoute: "/category",
      imgSrc: Cookies,
      categoryName: "Makanan",
      imgAlt : "Gambar makanan"
    },
    {
      categoryRoute: "/category",
      imgSrc: Fish,
      categoryName: "Ikan",
      imgAlt : "Gambar ikan"
    },
  ];
  return (
    <div className="w-full flex items-center relative">
      <button onClick={goPrev} className="w-12 p-2 absolute left-0 z-10 -ml-6">
        <LeftArrow className="w-8 text-white" />
      </button>
      <Swiper {...params} ref={swiperRef}>
        {categoryList.map((item, index) => (
          <div className="w-3/10" key={index}>
            <Link to={item.categoryRoute}>
              <div className="bg-white mx-3 py-4 px-6 rounded-lg">
                <div className="flex items-center">
                  <img alt={item.imgAlt} src={item.imgSrc} className="w-auto h-12 mr-4" />
                  <p className="tracking-0-4">{item.categoryName}</p>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </Swiper>
      <button
        onClick={goNext}
        className=" w-12 p-2 absolute right-0 z-10 -mr-6"
      >
        <RightArrow className="w-8 text-white" />
      </button>
    </div>
  );
};

export default CategorySlide;
